var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TradeWidgetV2',{staticClass:"trade-widget",attrs:{"asset":_vm.asset,"initialMode":_vm.initialMode,"hideTabSelector":""},on:{"refreshPageData":_vm.loadData}})}
var staticRenderFns = []

export { render, staticRenderFns }